export default "/_next/static/15630c906714a9491af61e4933831002.png";